module.exports = __webpack_public_path__ + "static/media/case-closed-531.3a70f1c1.mp3";